var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMenu(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 3.188h16v1.615H2V3.188zM2 9.033h16v1.615H2V9.033zM2 14.606h16v1.615H2v-1.615z",
    fill: "#25241D"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIHZpZXdCb3g9IjAgMCAyMCAyMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTIgMy4xODc1SDE4VjQuODAyNTdIMlYzLjE4NzVaIiBmaWxsPSIjMjUyNDFEIi8+CjxwYXRoIGQ9Ik0yIDkuMDMyNzFIMThWMTAuNjQ3OEgyVjkuMDMyNzFaIiBmaWxsPSIjMjUyNDFEIi8+CjxwYXRoIGQ9Ik0yIDE0LjYwNTdIMThWMTYuMjIwOEgyVjE0LjYwNTdaIiBmaWxsPSIjMjUyNDFEIi8+Cjwvc3ZnPgo=";
export { SvgMenu as ReactComponent };